<script lang="ts">
	import { createEventDispatcher } from 'svelte'
	import { writable, type Writable } from 'svelte/store'
	import { page } from '$app/stores'
	import { COUNTRY_CODE, LEAD_SOURCE } from '$lib/consts'
	import { Checkbox, Form } from '$lib/form'
	import Field from '$lib/form/Field.svelte'
	import FormButton from '$lib/form/FormButton.svelte'
	import RadioImage from '$lib/form/RadioImage.svelte'
	import { t } from '$lib/translations'
	import type { Snapshot } from './$types'
	import { PUBLIC_WOLTAIR_WEB_CODE } from '$env/static/public'
	import { DOCUMENTS } from '$params/documents'
	import { PRIVACY_POLICY } from '$params/privacy_policy'
	const dispatch = createEventDispatcher()
	export let leadZip = true
	export let subTitle: boolean | string = false
	export let fieldPhone: boolean = true
	export let fieldExpress: boolean = false
	export let fieldEmail: boolean = true
	export let productChoice: boolean = true
	export let fieldZip: boolean = true
	export let fieldAffiliate: boolean = false
	export let width: string = 'w-[500px]'
	export let maxw: number | boolean = false
	let user
	function getZipcodeValue(data) {
		if (!data || !data.data || !data.data.lead || !data.data.lead.attributes) {
			logger.error('Invalid data structure')
			return null
		}

		const attributes = data.data.lead.attributes
		const zipcodeAttribute = attributes.find((attr) => attr.key === 'zipcode')
		return zipcodeAttribute ? zipcodeAttribute.value : null
	}
	const handelSuccess = (event) => {
		success = true
		if (event.detail?.data?.lead?.uid) {
			leadUid = event.detail?.data?.lead?.uid
		}
		user = {
			...(event?.detail?.user?.email && { email_address: event.detail.user.email }),
			...(event?.detail?.user?.zipcode && { zip_code: event.detail.user.zipcode }),
			...(event?.detail?.user?.phone && { phone_number: event.detail.user.phone })
		}
		if (leadUid) {
			leadZip = getZipcodeValue(event.detail)
			dispatch('leadcreated', {
				leadUid,
				leadZip,
				user
			})
		}
	}
	const handleSubmit = (event) => {
		user = {
			...(event?.detail?.user?.email && { email_address: event.detail.user.email }),
			...(event?.detail?.user?.zipcode && { zip_code: event.detail.user.zipcode }),
			...(event?.detail?.user?.phone && { phone_number: event.detail.user.phone })
		}
		if (event.detail?.data?.lead?.uid) {
			leadUid = event.detail?.data?.lead?.uid
		}
		dispatch('leadsubmitted', {
			user,
			leadUid
		})
	}
	const handleAuditClick = (event) => {
		event.preventDefault()
		dispatch('auditclick', {
			leadUid,
			goto: event.target.href,
			user
		})
		if (event.detail?.data?.lead?.uid) {
			leadUid = event.detail?.data?.lead?.uid
		}
	}

	export const snapshot: Snapshot = {
		capture: () => $formData,
		restore: (val: any) => ($formData = val)
	}

	export let title: String = t('web.forms.leaveContact.onPage.title')
	export let leadSource: String
	export let leadUid: String | Boolean = false
	export let importdata = {}
	export let topimg: string | null = null
	export let action: string = '/marketplace/marketplaceLeadDetail'
	export let userZipcode
	let userEmail, userPhone, userAffiliate
	let formData: Writable<Record<string, any>> = writable({})
	logger.log('fieldExpress', fieldExpress)
	$formData = {
		...$formData,
		...importdata
	}
	// (fieldExpress && { quickInstall: fieldExpress })
	if (fieldExpress) $formData.quickInstall = fieldExpress
	logger.log('formData', $formData)
	let success = leadUid ?? false
	let showAffiliate = false
	$: affiliatePromptText = showAffiliate
		? t('web.woltadvisor.affiliate.ihavecode.hide')
		: t('web.woltadvisor.affiliate.ihavecode')
</script>

{#if !success}
	<section class="{width} max-w-full py-5 pt-4">
		{#if topimg}
			<img src={topimg} class="mx-auto mb-8 h-40 md:h-auto" alt="Woltair expert" />
		{/if}
		<div class="flex h-full w-full flex-col justify-end">
			<div class="mb-4 flex items-center gap-6 px-4">
				{#if !topimg}
					<img
						src="/images/icons/2023_ci/dark/document_sign.svg"
						alt={title}
						class="ml-auto h-16 w-20 object-contain px-4"
					/>
				{/if}
				<span class="block w-full text-xl font-semibold" class:text-center={topimg}>{title}</span>
			</div>
			{#if subTitle}
				<p class="p-4 text-center md:px-6">
					{subTitle}
				</p>
			{/if}
			<Form
				{formData}
				on:success={handelSuccess}
				on:beforeSubmit={handleSubmit}
				cls="flex flex-col h-full"
				{action}
				reset={false}
				updatePage={false}
			>
				<slot name="fields">
					<input type="hidden" name="leadSource" value={leadSource} />
					<input type="hidden" name="pathname" value={$page.url.pathname} />

					{#each Object.entries(importdata) as [n, v]}
						<input type="hidden" name={n} value={v} />
					{/each}
					<section class="block px-6">
						{#if productChoice}
							<div class="grid grid-cols-2 gap-1 rounded-lg bg-neutral-200 p-1">
								<RadioImage
									image="/images/icons/2023_ci/dark/flash.svg"
									weight="font-normal"
									value={LEAD_SOURCE.PV_MARKETPLACE}
									name="formType"
									placeholder={t('web.forms.photovoltaics')}
									>{t('web.forms.photovoltaics')}</RadioImage
								>
								<RadioImage
									weight="font-normal"
									value={LEAD_SOURCE.HVAC_MARKETPLACE}
									name="formType"
									placeholder={t('web.forms.heatPump')}>{t('web.forms.heatPump')}</RadioImage
								>
							</div>
						{/if}
						{#if fieldEmail}
							<Field
								weight="font-normal"
								bind:value={userEmail}
								name="email"
								placeholder={t('web.forms.email')}>{t('web.forms.email')}</Field
							>
						{/if}
						{#if fieldPhone}
							<Field
								weight="font-normal"
								bind:value={userPhone}
								name="phone"
								placeholder={t('web.forms.yourPhone')}>{t('web.forms.yourPhone')}</Field
							>
						{/if}
						{#if fieldZip}
							<Field
								weight="font-normal"
								bind:value={userZipcode}
								name="zipcode"
								placeholder={t('web.forms.zipcode')}>{t('web.forms.zipcode')}</Field
							>
						{/if}
						{#if fieldExpress}
							<Checkbox name="quickInstall" bind:value={fieldExpress}
								>{@html t('web.woltadvisor.quickInstall')}
								<div class="text-xs">
									{t('web.woltadvisor.quickInstall.note')}
								</div>
							</Checkbox>
						{/if}
						{#if ['WOLTAIR_IT', 'WOLTAIR_PL'].includes(PUBLIC_WOLTAIR_WEB_CODE)}
							<Checkbox name="marketingConsentGeneral"
								>{@html t('web.forms.conditions.asCheckbox', {
									class: 'text-primary-500',
									link: `/${DOCUMENTS}/${PRIVACY_POLICY}`
								})}</Checkbox
							>
						{/if}
						{#if fieldAffiliate}
							{#if showAffiliate}
								<Field weight="font-normal" bind:value={userAffiliate} name="affiliate"
									>{t('web.woltadvisor.affiliate.enterPromoCode')}</Field
								>
							{/if}
							<button
								class="w-full text-center text-xs text-secondary-50"
								on:click={(e) => {
									e.preventDefault()
									showAffiliate = !showAffiliate
								}}
								>{affiliatePromptText}
							</button>
						{/if}
					</section>
				</slot>
				<div class="mt-auto h-fit w-full p-4 md:px-6">
					<FormButton
						shape="rounded-xl"
						type="text-white bg-secondary-500"
						cls="block w-full text-lg w-full"
						icon={false}>{t('web.forms.submit')}</FormButton
					>
				</div>
			</Form>
			<p class="tc mx-2 my-4 text-center text-xs opacity-60">
				{@html t('general.woltairConditions')}
			</p>
		</div>
	</section>
{:else}
	<div
		class=" max-w-full items-center gap-4 py-8 text-center"
		style:width={maxw ? maxw + 'px' : '1000px'}
	>
		<slot name="success">
			<img
				src="/images/logos/woltair-favicon-old.svg"
				alt={t('web.forms.leaveCotact.thankYou')}
				class="mx-auto h-20 w-20"
			/>
			{#if !leadZip && COUNTRY_CODE == 'DE'}
				<p class="p-4 text-xl">
					{@html t('web.offer.unservicedRegion')}
				</p>
				<p class="p-4">
					{@html t('web.marketplace.nextSteps.info')}
				</p>
			{:else}
				<h2 class="unstyled block px-8 text-4xl font-semibold">
					{@html t('web.marketplace.nextSteps.thanks')}
				</h2>
				<p class="mx-auto my-8 max-w-[800px] px-8">
					{@html t('web.marketplace.nextSteps.thanks.subtext')}
				</p>
				<div class="m-10 flex flex-col justify-center gap-2 text-left md:flex-row">
					<div
						class="flex w-80 flex-col justify-between rounded-2xl border bg-neutral-100 p-4 text-sm"
					>
						<div class="block">
							<p class="mb-4 font-semibold">{t('web.marketplace.nextSteps.selfservice.heading')}</p>
							<div class="my-2 flex md:my-6">
								<img src="/images/icons/2023_ci/dark/check-green.svg" alt="" class="pr-2" />
								<span>{t('web.marketplace.nextSteps.selfservice.discount')}</span>
							</div>
							<div class="my-2 flex md:my-6">
								<img src="/images/icons/2023_ci/dark/check-green.svg" alt="" class="pr-2" />
								<span>{t('web.marketplace.nextSteps.selfservice.quickOffer')}</span>
							</div>
							<div class="my-2 flex md:my-6">
								<img src="/images/icons/2023_ci/dark/check-green.svg" alt="" class="pr-2" />
								<span>{t('web.marketplace.nextSteps.selfservice.expert')}</span>
							</div>
						</div>
						<a
							on:click={(e) => {
								handleAuditClick(e)
							}}
							href={`https://selfservice.${$page.url.hostname.replace('www.', '')}/${leadUid}`}
							class="text-bold mt-4 block w-full rounded-xl border bg-secondary-500 p-2 py-3 text-center text-white"
							>{t('web.marketplace.nextSteps.selfservice.start')}</a
						>
					</div>
					<!-- <div class="rounded-2xl border p-4 text-sm">
				<p class="mb-4 font-semibold">{t('web.marketplace.nextSteps.homeVisit.title')}</p>
				<div class="my-2 flex">
					<img src="/images/icons/2023_ci/dark/cross.svg" alt="Not included" class="pr-2" />
					<span>{t('web.marketplace.nextSteps.homeVisit.discountOffer')}</span>
				</div>
				<div class="my-2 flex">
					<img src="/images/icons/2023_ci/dark/check-green.svg" alt="" class="pr-2" />
					<span>{t('web.marketplace.nextSteps.homeVisit.quickOffer')}</span>
				</div>
				<div class="my-2 flex">
					<img src="/images/icons/2023_ci/dark/check-green.svg" alt="" class="pr-2" />
					<span>{t('web.marketplace.nextSteps.homeVisit.expert')}</span>
				</div>
				<a href="#visit" class="text-bold mt-4 block w-full rounded-xl border p-2 py-3 text-center"
					>{t('web.marketplace.nextSteps.homeVisit.schedule')}</a
				>
			</div> -->
					<div class="flex w-80 flex-col justify-between rounded-2xl border p-4 text-sm">
						<div class="block">
							<p class="mb-4 font-semibold">{t('web.marketplace.nextSteps.online.heading')}</p>
							<div class="my-2 flex md:my-6">
								<img src="/images/icons/2023_ci/dark/cross.svg" alt="" class="pr-2" />
								<span>{t('web.marketplace.nextSteps.online.discountOffer')}</span>
							</div>
							<div class="my-2 flex md:my-6">
								<img src="/images/icons/2023_ci/dark/check-green.svg" alt="" class="pr-2" />
								<span>{t('web.marketplace.nextSteps.online.quickOffer')}</span>
							</div>
							<div class="my-2 flex md:my-6">
								<img src="/images/icons/2023_ci/dark/check-green.svg" alt="" class="pr-2" />
								<span>{t('web.marketplace.nextSteps.online.anytime')}</span>
							</div>
						</div>
						<div class="text-bold mt-4 block w-full rounded-xl border p-2 py-3 text-center">
							{t('web.marketplace.nextSteps.online.infoblock')}
						</div>
					</div>
				</div>
				<p class="info">{@html t('web.marketplace.nextSteps.info')}</p>
			{/if}
		</slot>
	</div>
{/if}

<style lang="scss">
	.tc :global(a) {
		@apply underline;
	}
	.info :global(a) {
		@apply text-primary-500;
		@apply underline;
	}
</style>
